export const DATE_TIME_PICKER_INPUT_HEIGHT = 40;
export const DATE_TIME_PICKER_VALUE_FONT_SIZE = 14;
export const INPUT_LABEL_NUDGE = -8;
export const DATE_TIME_PICKER_POPUP_CLASS_NAME = 'f-date-time-picker-popup';
export const DATE_TIME_PICKER_CLASS_NAME = 'f-date-time-picker';
/** MUI's outlined-input outline class; the hand-rolled notch fieldset reuses it so the shared `OUTLINED_BORDER_SX` selectors apply. */
export const NOTCHED_OUTLINE_CLASS_NAME = 'MuiOutlinedInput-notchedOutline';
